<template>
  <div class="row">
    <div class="col-3">
      <search-transfer
        class="search"
        @listenTransferNumber="listenTransferNumber"
      />
    </div>
    <div class="col-9">
      <vue-good-table
        class="vue-table"
        ref="table"
        @row-click="onRowClick"
        @page-change="onPageChange"
        @sort-change="onSortChange"
        @column-filter="onColumnFilter"
        @per-page-change="onPerPageChange"
        :isLoading.sync="isLoading"
        :pagination-options="paginationOptions"
        :totalRows="transferStore.totalTransferReports"
        :rows="transferReportList"
        :columns="paginationData.columns"
      >
        <template #table-actions-bottom>
          <pagination-records
            :pages="serverParams.page"
            :per-page="serverParams.perPage"
            :total="transferStore.totalTransferReports"
          />
        </template>
        <template #table-row="props">
          <span v-if="props.column.field == 'download'">
            <button
              class="btn btn-primary"
              style="margin-right: 10px"
              @click="summaryReport()"
            >
              Report Summary
            </button>
            <button
              class="btn btn-primary"
              style="margin-right: 10px"
              @click="detailsReport()"
            >
              Report Details
            </button>
            <button class="btn btn-primary" @click="errorReport()">
              Error Report
            </button>
            <!-- <Popper arrow hover>
              <i class="material-icons">download</i>
              <template #content class="popper">Report Summary</template>
            </Popper>
            <Popper arrow hover>
              <i class="material-icons">download</i>
              <template #content>Report Details</template>
            </Popper>
            <Popper arrow hover>
              <i class="material-icons">download</i>
              <template #content>Error Report</template>
            </Popper> -->
            <!-- <div hidden>
              <div
                id="customContent"
                data-name="popover-content"
                style="width: 100px"
              >
                <div class="row g-0">
                  <button type="button" class="btn btn-actions summary">
                    Report Summary
                  </button>
                  <button type="button" class="btn btn-actions details">
                    Report Details
                  </button>
                  <button type="button" class="btn btn-actions error">
                    Error Report
                  </button>
                </div>
              </div>
            </div>
            <a
              tabindex="0"
              class="btn btn-ellipsis"
              role="button"
              data-bs-toggle="popover"
              data-bs-placement="left"
              ><i class="material-icons ellipsis">more_vert</i>
            </a> -->
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
  <manage-reports-modal />
</template>

<script setup lang="ts">
import SearchTransfer from "@/components/DownloadReport/SearchTransfer.vue";
import ManageReportsModal from "@/components/Modal/ManageReportsModal.vue";
import PaginationRecords from "@/components/Pagination/PaginationRecords.vue";
import { useSortConversionReport } from "@/composables/useStringConversion";
import { useTransferStore } from "@/stores/content_review/transfer";
import { useAudit } from "@/stores/audit";
import { usePDF } from "@/stores/report_pdf";
import { useAsyncState } from "@vueuse/core";
import { Popover } from "bootstrap/dist/js/bootstrap.esm.min.js";
import moment from "moment";
import { ref, onUpdated, watch } from "vue";

// onUpdated(() => {
//   let customContent: any = document.getElementById("customContent");
//   Array.from(document.querySelectorAll('a[data-bs-toggle="popover"]')).forEach(
//     (popoverNode, index) => {
//       const clone = customContent.cloneNode(true);
//       let buttonSummary = clone.getElementsByClassName("summary")[0];
//       buttonSummary.addEventListener("click", () => summaryReport(index));
//       let buttonDetails = clone.getElementsByClassName("details")[0];
//       buttonDetails.addEventListener("click", () => detailsReport(index));
//       let buttonError = clone.getElementsByClassName("error")[0];
//       buttonError.addEventListener("click", () => errorReport(index));
//       var popoverScript = `
//           new bootstrap.Popover(popoverNode, {
//             trigger: "focus",
//             html: true,
//             content: clone,
//           });
//         `;
//       eval(popoverScript);
//     }
//   );
// });

const table = ref();
const transferStore = useTransferStore();
const isLoading = ref(false);
const selectedRow = ref(transferStore.transferReportList[0]);
const reportSummary: any = ref([]);
const pdfStore = usePDF();
const audit = useAudit();

watch(
  () => transferStore.reportSummary,
  (updateReport) => {
    reportSummary.value = [];
    reportSummary.value.push(updateReport);
  }
);

watch(
  () => transferStore.loading,
  (updateLoading) => {
    isLoading.value = updateLoading;
  }
);

const transferReportList: any = ref([]);

watch(
  () => transferStore.transferReportList,
  (updateList) => {
    transferReportList.value = updateList;
  }
);

const paginationOptions = ref({
  enabled: true,
  mode: "pages",
  position: "bottom",
  perPageDropdown: [10, 20, 30, 50],
  perPage: 20,
  dropdownAllowAll: false,
});

const serverParams = ref({
  columnFilters: [
    {
      fieldName: "transferBatch",
      filterText: "",
    },
    {
      fieldName: "transferringAgency",
      filterText: "",
    },
  ],
  sort: { field: "date", type: "desc" },
  page: 1,
  perPage: paginationOptions.value.perPageDropdown[1],
});

let paginationData = {
  totalRecords: transferStore.totalTransferReports,
  columns: [
    {
      label: "Title",
      field: function (rowObj) {
        return rowObj.title ? rowObj.title : "-";
      },
      sortable: false,
      width: "300px",
    },
    {
      label: "Date",
      field: "date",
      formatFn: function (value) {
        if (value == null || value == "") return "-";
        else return moment(value).format("DD MMM yyyy HH:mm:ss");
      },
      sortable: false,
      width: "120px",
    },
    {
      label: "Transferring Agency",
      field: function (rowObj) {
        return rowObj.transferringAgency ? rowObj.transferringAgency : "-";
      },
      sortable: false,
      width: "180px",
    },
    {
      label: "Transfer Date",
      field: "transferDate",
      formatFn: function (value) {
        if (
          value == null ||
          value == "" ||
          moment(value).format("DD MMM yyyy") == "01 Jan 0001"
        )
          return "-";
        else return moment(value).format("DD MMM yyyy");
      },
      sortable: false,
      width: "120px",
    },
    {
      label: "Transfer Batch No",
      field: function (rowObj) {
        return rowObj.transferBatchNumber ? rowObj.transferBatchNumber : "-";
      },
      sortable: false,
      width: "120px",
    },
    {
      label: "Number Of Items",
      field: function (rowObj) {
        return rowObj.numberOfItems ? rowObj.numberOfItems : "0";
      },
      sortable: false,
      width: "110px",
    },
    {
      label: "Number Of Computer Files",
      field: function (rowObj) {
        return rowObj.numberOfComputerFiles
          ? rowObj.numberOfComputerFiles
          : "0";
      },
      sortable: false,
      width: "160px",
    },
    {
      label: "Number Of Errors",
      field: function (rowObj) {
        return rowObj.numberOfErrors ? rowObj.numberOfErrors : "0";
      },
      sortable: false,
      width: "110px",
    },
    {
      label: "Total Size",
      field: function (rowObj) {
        if (rowObj.totalSize) {
          var size = rowObj.totalSize;
          if (size >= 1073741824) {
            size = (size / 1073741824).toFixed(2) + " GB";
          } else {
            size = (size / 1048576).toFixed(2) + " MB";
          }
          return size;
        } else return "-";
      },
      sortable: false,
      width: "80px",
    },
    {
      label: "Transfer Outcome",
      field: function (rowObj) {
        return rowObj.transferOutcome ? rowObj.transferOutcome : "-";
      },
      sortable: false,
      width: "100px",
    },
    {
      label: "Transfer ID",
      field: function (rowObj) {
        return rowObj.transferId ? rowObj.transferId : "-";
      },
      sortable: false,
      width: "200px",
    },
    {
      label: "Download",
      field: "download",
      sortable: false,
      width: "390px",
    },
  ],
};

const { execute } = useAsyncState(() => {
  return transferStore.fetchTransferReportList(
    serverParams.value.perPage,
    useSortConversionReport(serverParams.value.sort) as string,
    serverParams.value.columnFilters as Array<object>
  );
}, null);

const updateParams = (newProps: any) => {
  serverParams.value = Object.assign({}, serverParams.value, newProps);
};

const onPageChange = (params) => {
  updateParams({
    perPage: params.currentPerPage,
    page: params.currentPage,
  });
};

const onPerPageChange = (params) => {
  updateParams({
    perPage: params.currentPerPage,
    page: 1,
  });
};

const onSortChange = (params) => {
  updateParams({
    sort: {
      type: params[0].type,
      field: params[0].field,
    },
    perPage: params.currentPerPage,
    page: 1,
  });
};

const onColumnFilter = (params) => {
  transferReportList.value = [];
  table.value.reset();
  updateParams({
    sort: { type: "desc", field: "date" },
    page: 1,
  });
  execute();
};

const listenTransferNumber = (inputParams) => {
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "transferBatch"
        ? { ...obj, filterText: inputParams.transferBatch }
        : obj
  );
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "transferringAgency"
        ? { ...obj, filterText: inputParams.transferringAgency }
        : obj
  );
  onColumnFilter(serverParams);
};

const onRowClick = async (params) => {
  selectedRow.value = params.row;
  // console.log("123", selectedRow.value);
};

const summaryReport = async () => {
  setTimeout(() => {
    audit.auditLog("Transfer Report Summary")
    transferStore.transferReportSummary(selectedRow.value.transferId);
  }, 500);
};

const detailsReport = async () => {
  setTimeout(() => {
    transferStore.transferReportAppendix(selectedRow.value.transferId);
  }, 1000);
};

const errorReport = async () => {
  setTimeout(() => {
    transferStore.transferReportError(selectedRow.value.transferId);
  }, 1000);
};
</script>

<style scoped>
.vue-table {
  position: relative;
  top: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
}
</style>
